import ApiServices from '@/services/api'
import globalMixin from '@/mixins'
let that = globalMixin.methods

// --->>>>>>>>>>>>>>>   All Rate List api call   <<<<<<<<<<<<<<---
const RATE_LIST = ({commit}, page) => {
  return ApiServices.getRateList(page)
    .then(response => {
      commit('getRateList', response)
      // console.log("getRateList=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Add Site api call   <<<<<<<<<<<<<<---
const ADD_RATE = ({commit}, data) => {
  return ApiServices.addRate(data)
    .then(response => {
      commit('addRate', response)
      // console.log("addRate=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Updae Site api call   <<<<<<<<<<<<<<---
const UPDATE_RATE = ({ commit }, data) => {
  return ApiServices.updateRate(data)
    .then(response => {
      commit('updateRate', response)
      // console.log("updateRate=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Updae Site api call   <<<<<<<<<<<<<<---
const RATE_STATUS_CHANGE = ({commit}, data) => {
  return ApiServices.delRate(data)
    .then(response => {
      commit('rateStatus', response)
      // console.log("updateRate=====", response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}



export default {
  RATE_LIST,
  ADD_RATE,
  UPDATE_RATE,
  RATE_STATUS_CHANGE
}



// WEBPACK FOOTER //
// ./src/store/modules/rateManagement/actions.js